<template>
  <div class="app-container">
    <div class="header">
      时间段
      <el-date-picker
        v-model="listQuery.start_datetime"
        type="date"
        class="filter-item"
        placeholder="开始日期"
      ></el-date-picker
      >至
      <el-date-picker
        v-model="listQuery.end_datetime"
        type="date"
        class="filter-item"
        placeholder="结束日期"
      ></el-date-picker>
      <el-input
        v-model="listQuery.search"
        placeholder="请输入用户名/电话"
        style="width: 200px;margin-left:10px;"
        class="filter-item"
        :clearable="true"
      />
      <el-select
        v-model="listQuery.is_forbidden"
        placeholder="是否冻结"
        :clearable="true"
        style="width: 110px;margin-left:10px"
        class="filter-item"
      >
        <el-option label="正常" value="0" />
        <el-option label="冻结" value="1" />
      </el-select>
      <el-select
        v-model="listQuery.is_certification"
        placeholder="是否实名"
        :clearable="true"
        style="width: 110px;margin-left:10px"
        class="filter-item"
      >
        <el-option label="是" value="1" />
        <el-option label="否" value="2" />
      </el-select>
      <el-select
        v-model="listQuery.is_proxy"
        placeholder="是否代理"
        :clearable="true"
        style="width: 110px;margin-left:10px"
        class="filter-item"
      >
        <el-option label="是" value="1" />
        <el-option label="否" value="0" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        style="margin-left:10px"
        >搜索</el-button
      >
    </div>
    <div class="filter-container" style="margin-top:10px">
      <el-row type="flex" class="row-bg">
        <el-col :span="3">
          <div class="grid-content bg-purple" style="line-height:48px;">
            用户数量：{{ user_count }}
          </div>
        </el-col>
        <el-col :span="21">
          <div class="grid-content bg-purple-light">
            <el-form
              :inline="true"
              :model="formInline"
              class="demo-form-inline"
            >
              <el-col :span="12">
          
                <el-form-item label="分销佣金比例" >
                  
                    <el-col :span="6">
                      <el-input
                        v-model="formInline.level1_ratio"
                        placeholder="一级比率"
                        :clearable="true"
                       @input="recordNum('level1_ratio')"
                      ></el-input>
                    </el-col>
                    <el-col :span="1">%</el-col>
                    <el-col :span="6">
                      <el-input
                        v-model="formInline.level2_ratio"
                        placeholder="二级比率"
                        :clearable="true"
              @input="recordNum('level2_ratio')"
                      ></el-input>
                    </el-col>
                    <el-col :span="2">%</el-col>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="会员价格">
                  <el-input
                    v-model="formInline.price"
                    placeholder
                    :clearable="true"
                    @input="recordArrPrice('price')"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submit">提交</el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="头像" min-width="150" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.avatar" alt style="width: 110px;" />
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.nickname }}
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="性别" min-width="70" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.gender == 0">未设置</span>
          <span v-else-if="scope.row.gender == 1">男</span>
          <span v-else-if="scope.row.gender == 2">女</span>
        </template>
      </el-table-column>
      <el-table-column label="是否实名" min-width="80" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.is_certification == 0">
            <el-tag type="info">否</el-tag>
          </div>
          <div v-else-if="scope.row.is_certification == 1">
            <el-tag type="success">是</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否会员" min-width="80" align="center">
        <template slot-scope="scope">
          <div
            v-if="
              !scope.row.member ||
                (scope.row.member && scope.row.member.type == 0)
            "
          >
            <el-tag type="info">否</el-tag>
          </div>
          <div v-else-if="scope.row.member && scope.row.member.type == 1">
            <el-tag type="success">是</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="会员到期时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.member ? scope.row.member.expiration_date : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="是否代理" min-width="80" align="center">
        <template slot-scope="scope">
          <div v-if="!scope.row.is_proxy">
            <el-tag type="info">否</el-tag>
          </div>
          <div v-else>
            <el-tag type="success">是</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="积分" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_account.integral }}
        </template>
      </el-table-column>
      <el-table-column label="余额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_account.balance }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="注册时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="最新活跃时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.updated_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        min-width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_forbidden == 0" type="success"
            >正常</el-tag
          >
          <el-tag v-else type="warning">已冻结</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="left"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-row>
            <el-button
              style="margin:5px"
              type="primary"
              size="mini"
              @click="showUserInfo(scope.row)"
              >详细信息</el-button
            >
            <el-button
              style="margin:5px"
              type="warning"
              @click="gotolink(scope.row.id,scope.row.nickname, scope.row.is_proxy)"
              size="mini"
              >分销</el-button
            >
          </el-row>
          <el-button
            style="margin:5px"
            v-if="scope.row.is_proxy == 0"
            type="success"
            size="mini"
            @click="handleForbid(scope.row.id, '设为代理')"
            >设为代理</el-button
          >
          <el-button
            style="margin:5px"
            v-else
            size="mini"
            type="danger"
            @click="handleForbid(scope.row.id, '取消代理')"
            >取消代理</el-button
          >
          <el-button
            style="margin:5px"
            v-if="
              !scope.row.member ||
                (scope.row.member && scope.row.member.type == 0)
            "
            type="success"
            size="mini"
            @click="handleVIP(scope.row.id, '开通会员，有效期1年',scope.row.nickname)"
            >设为会员</el-button
          >
          <el-button
            style="margin:5px"
            v-else
            size="mini"
            type="danger"
            @click="handleVIP(scope.row.id, '续费会员，会员续费1年',scope.row.nickname)"
            >续费会员</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog title="详情" v-if="showInfo" :visible.sync="showInfo">
      <el-form ref="form" :model="info" label-width="120px">
        <!-- <el-form-item label="序号">
          <div>{{ info.$index+1 }}</div>
        </el-form-item> -->
        <el-form-item label="头像">
          <div><img :src="info.avatar" alt style="width: 150px;" /></div>
        </el-form-item>
        <el-form-item label="昵称">
          <div>{{ info.nickname }}</div>
        </el-form-item>
        <el-form-item label="联系电话">
          <div>{{ info.phone }}</div>
        </el-form-item>
        <el-form-item label="性别">
          <div>
            <span v-if="info.gender == 0">未设置</span>
            <span v-else-if="info.gender == 1">男</span>
            <span v-else-if="info.gender == 2">女</span>
          </div>
        </el-form-item>

        <el-form-item label="是否实名">
          <div v-if="info.is_certification == 0">
            <el-tag type="info">否</el-tag>
          </div>
          <div v-else-if="info.is_certification == 1">
            <el-tag type="success">是</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="是否会员">
          <div v-if="!info.member || (info.member && info.member.type == 0)">
            <el-tag type="info">否</el-tag>
          </div>
          <div v-else-if="info.member && info.member.type == 1">
            <el-tag type="success">是</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="是否代理">
          <div v-if="info.is_proxy == 0">
            <el-tag type="info">否</el-tag>
          </div>
          <div v-else-if="info.is_proxy == 1">
            <el-tag type="success">是</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="积分">
          <div>
            <div>{{ info.user_account.integral }}</div>
          </div>
        </el-form-item>
        <el-form-item label="余额">
          <div>
            <div>{{ info.user_account.balance }}</div>
          </div>
        </el-form-item>
        <el-form-item label="注册时间">
          <div>
            <div>{{ info.created_at }}</div>
          </div>
        </el-form-item>
        <el-form-item label="最新活跃时间">
          <div>
            <div>{{ info.updated_at }}</div>
          </div>
        </el-form-item>
        <el-form-item label="状态">
          <div>
            <el-tag v-if="info.is_forbidden == 0" type="success">正常</el-tag>
            <el-tag v-else type="warning">已冻结</el-tag>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      info: {},
      showInfo: false,
      list: [],
      total: null,
      user_count: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        start_datetime: "",
        end_datetime: "",
        search: "",
        is_forbidden: "",
        is_certification: "",
        is_proxy: "",
      },
      formInline: {
        level1_ratio: "",
        level2_ratio: "",
        price: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/user",
        method: "get",
        params: this.listQuery,
      })
        .then((response) => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.user_count = response.data.user_count;
          this.listLoading = false;
          this.formInline.price = response.data.price;
          this.formInline.level1_ratio = response.data.ratio.level1_ratio;
          this.formInline.level2_ratio = response.data.ratio.level2_ratio;
        })
        .catch((err) => {
          console.log(err);
          this.$notify.error(err);
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/user/proxy",
            method: "get",
            params: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleVIP(val, text,nickname) {
      this.$confirm("此操作将为 " + nickname + " " + text + ", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/user/memberSetUpOrRenew",
            method: "get",
            params: { userId: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    gotolink(userId, nickname,isProxy) {
      this.$router.push(
        "/user/distribution?userId=" + userId+ "&nickname=" + nickname + "&isProxy=" + isProxy
      );
    },
    showUserInfo(row) {
      this.info = row;
      this.showInfo = true;
    },
     recordArrPrice(e) {
      if (e == "price") {
        this.formInline.price =
        this.formInline.price.match(/^\d*(\.?\d{0,2})/g)[0] ||
        null;}
      // } else if (type == "origin_price") {
      //   this.form.product_recommend[e].origin_price =
      //   this.form.product_recommend[e].origin_price.match(/^\d*(\.?\d{0,2})/g)[0] ||
      //   null;
      // } 
    },
     recordNum(e) {
      if (e == "level1_ratio") {
        this.formInline.level1_ratio =
        this.formInline.level1_ratio.match(/^[1-9]\d*/g)[0] ||
        null;
      } 
      else if (e == "level2_ratio") {
        this.formInline.level2_ratio =
        this.formInline.level2_ratio.match(/^[1-9]\d*/g)[0] ||
        null;
      } 
      // else if (e == "stock") {
      //   this.form.stock =
      //   this.form.stock.match(/^\d*(\.?\d{0,2})/g)[0] ||
      //   null;
      // }
    },
    submit() {
      request({
        url: "/api/backend/setSave",
        method: "post",
        params: this.formInline,
      }).then(() => {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
